import { callAPi } from "./api";

// Existing services for proxy URLs
const create = (data) => callAPi.post("/admin/proxy", data);
const edit = (data, id) => callAPi.patch(`/admin/proxy/${id}`, data);
const get = () => callAPi.get("/proxy");
const getByID = (id) => callAPi.get(`/proxy/${id}`);
const deleteProxy = (id) => callAPi.delete(`/admin/proxy/${id}`);

// New services for proxy forms
const submitProxyForm = (data) => callAPi.post("/proxy-forms", data);
const getProxyForms = (params) => callAPi.get("/admin/proxy-forms", { params });
const getProxyFormByID = (id) => callAPi.get(`/admin/proxy-forms/${id}`);
const deleteProxyForm = (id) => callAPi.delete(`/admin/proxy-forms/${id}`);

const proxyServices = {
  create,
  edit,
  get,
  deleteProxy,
  getByID,
  // New proxy form services
  submitProxyForm,
  getProxyForms,
  getProxyFormByID,
  deleteProxyForm,
};

export default proxyServices;
